
import img_scikit_learn from "../../assets/images/ai-band/packages/scikit-learn.svg";
import img_tensorflow from "../../assets/images/ai-band/packages/tensorflow.svg";
import img_opencv from "../../assets/images/ai-band/packages/opencv.svg";
import img_numpy from "../../assets/images/ai-band/packages/numpy.svg";
import img_pandas from "../../assets/images/ai-band/packages/pandas.svg";
import img_matplotlib from "../../assets/images/ai-band/packages/matplotlib.svg";
import img_pygame from "../../assets/images/ai-band/packages/pygame.svg";
import img_music from "../../assets/images/ai-band/packages/music.svg";
import img_pen from "../../assets/images/ai-band/packages/pen.svg";
import img_video_sensing from "../../assets/images/ai-band/packages/video-sensing.svg";
import img_face_detection from "../../assets/images/ai-band/packages/face-detection.svg";
import img_human_hand_pose from "../../assets/images/ai-band/packages/human-hand-pose.svg";
import img_object_detection from "../../assets/images/ai-band/packages/object-detection.svg";
import img_speech_recognition from "../../assets/images/ai-band/packages/speech-recognition.svg";
import img_text_to_speech from "../../assets/images/ai-band/packages/text-to-speech.svg";
import img_nlp_toolbox from "../../assets/images/ai-band/packages/nlp-toolbox.svg";
import img_translation_service from "../../assets/images/ai-band/packages/translation-service.svg";
import img_math_helper from "../../assets/images/ai-band/packages/math-helper.svg";
import img_makey_makey from "../../assets/images/ai-band/packages/makey-makey.svg";
import img_micro_bit from "../../assets/images/ai-band/packages/micro-bit.svg";
import img_lego_mindstorms_ev3 from "../../assets/images/ai-band/packages/lego-mindstorms-ev3.svg";
import img_lego_boost from "../../assets/images/ai-band/packages/lego-boost.svg";
import img_lego_education_wedo_2_0 from "../../assets/images/ai-band/packages/lego-education-wedo-2-0.svg";
import img_go_direct_force_acceleration from "../../assets/images/ai-band/packages/go-direct-force-acceleration.svg";
import img_text_to_speech_2 from "../../assets/images/ai-band/packages/text-to-speech-2.svg";

export const PYTHON_PACKAGES = [
  { logo: img_scikit_learn, name: "scikit-learn", description: "Machine learning models" },
  { logo: img_tensorflow, name: "TensorFlow", description: "Deep learning & neural nets" },
  { logo: img_opencv, name: "OpenCV", description: "Computer vision" },
  { logo: img_numpy, name: "NumPy", description: "Scientific computing" },
  { logo: img_pandas, name: "Pandas", description: "Data manipulation & analysis" },
  { logo: img_matplotlib, name: "Matplotlib", description: "Data visualization" },
  { logo: img_pygame, name: "pygame", description: "Create games" },
];

export const BLOCK_EXTENSIONS = [
  { logo: img_music, name: "Music", description: "Play instruments and drums" },
  { logo: img_pen, name: "Pen", description: "Draw with your sprites" },
  { logo: img_video_sensing, name: "Video Sensing", description: "Sense motion with the camera" },
  { logo: img_face_detection, name: "Face Detection", description: "Detect faces & expressions" },
  { logo: img_human_hand_pose, name: "Human Hand & Pose", description: "Detect hand and body pose" },
  { logo: img_object_detection, name: "Object Detection", description: "Detect objects with ML" },
  { logo: img_speech_recognition, name: "Speech Recognition", description: "Convert speech to text" },
  { logo: img_text_to_speech, name: "Text to Speech", description: "Make your projects talk" },
  { logo: img_nlp_toolbox, name: "NLP Toolbox", description: "Analyze text with language AI" },
  { logo: img_translation_service, name: "Translation Service", description: "Translate text on the fly" },
  { logo: img_math_helper, name: "Math Helper", description: "Add numbers together" },
  { logo: img_makey_makey, name: "Makey Makey", description: "Make anything into a key" },
  { logo: img_micro_bit, name: "micro:bit", description: "Connect projects with the world" },
  { logo: img_lego_mindstorms_ev3, name: "LEGO MINDSTORMS EV3", description: "Build interactive robots" },
  { logo: img_lego_boost, name: "LEGO BOOST", description: "Bring robotic creations to life" },
  { logo: img_lego_education_wedo_2_0, name: "LEGO Education WeDo 2.0", description: "Build with motors and sensors" },
  { logo: img_go_direct_force_acceleration, name: "Go Direct Force & Acceleration", description: "Sense push, pull, motion & spin" },
  { logo: img_text_to_speech_2, name: "Text to Speech", description: "Convert text to spoken words" },
];
